import { createContext } from 'react';
import { System_DeviceOrientationMap } from './assets/keyMap';

//classes
//GENERAL
import MemberUser from './classes/memberUser';
import CommitteeType from './exClasses/committeeType';
import EventCategory from './exClasses/eventCategory';
import MemberType from './exClasses/memberType';
import MemberFee from './exClasses/memberFee';
import InvoiceNote from './exClasses/invoiceNote';
import DocumentCategory from './exClasses/documentCategory';
import Broadcast from './classes/broadcast';
import Event from './exClasses/event';
import Document from './exClasses/document';
import Notification from './classes/notification';
//MEMBER USERS
import MembershipRegistration from './exClasses/membershipRegistration';
import Member from './classes/member';
import MembershipContract from './exClasses/membershipContract';
import EventRegistration from './exClasses/eventRegistration';
//COMMITTEES
import MeetingInvitation from './exClasses/meetingInvitation';
import EventItem from './exClasses/eventItem';
import Poll from './exClasses/poll';
//OTHERS
// import Sponsor from './classes/sponsor'; ---deprecated of unused

export const AppContext = createContext({
    //app config
    dburl: '', secret: '', appLink: { android: '', ios: '' }, appBuild: '0',
    deviceOrientation: System_DeviceOrientationMap.LANDSCAPE as number, SetDeviceOrientation: (value: number) => {},
    // newbiePrompt: false as boolean, SetNewbiePrompt: (value: boolean) => {}, ---deprecated
    rememberedEmail: '' as string, SetRememberedEmail: (value: string) => {},
    rememberedPassword: '' as string, SetRememberedPassword: (value: string) => {},
    usersAgreement: false, SetUsersAgreement: (value: boolean) => { },
    safeArea: {} as any, SetSafeArea: (value: any) => { },
    //frame components, header, navBar, sideBar, footer
    headerShouldHide: false, SetHeaderShouldHide: (value: boolean) => { },
    navBarShouldHide: false, SetNavBarShouldHide: (value: boolean) => { },
    headerBackAction: {} as any, SetHeaderBackAction: (value: any) => { },
    headerTitle: '' as string, SetHeaderTitle: (value: string) => { },
    //sidebar
    sideBarShouldHide: false, SetSideBarShouldHide: (value: boolean) => { },
    //language
    language: 'en', SetLanguage: (value: string) => { },
    //popup message box
    popupMessage: '', SetPopupMessage: (value: string) => { },
    popupButtons: ['Ok'] as string[], SetPopupButtons: (value: string[]) => { },
    popupActions: [() => { }] as any[], SetPopupActions: (value: any[]) => { },
    //popup instruction box
    popupInstructions: [] as string[], SetPopupInstructions: (value: string[]) => { },
    popupPreviews: [] as string[], SetPopupPreviews: (value: string[]) => { },
    popupShouldSvgAnimations: [] as string[], SetPopupShouldSvgAnimations: (value: string[]) => { },
    popupInstructAction: {} as any, SetPopupInstructAction: (value: any) => { },
    //ageeement box
    agreementMessage: '', SetAgreementMessage: (value: string) => { },
    //otp screen
    otpTitle: '', SetOtpTitle: (value: string) => {},
    otpVerificationCode: '', SetOtpVerificationCode: (value: string) => { },
    otpSubject: '', SetOtpSubject: (value: string) => { },
    otpMode: 0, SetOtpMode: (value: number) => { },
    otpResultAction: {} as any , SetOtpResultAction: (value: any) => { },
    //pin number keypad
    pinNumberVerificationKey: '', SetPinNumberVerificationKey: (value: string) => {},
    pinNumberVerificationMessage: '', SetPinNumberVerificationMessage: (value: string) => {},
    pinNumberSuccessAction: {} as any, SetPinNumberSuccessAction: (value: any) => {},
    pinNumberResetPinAction: {} as any, SetPinNumberResetPinAction: (value: any) => {},
    //wait screen
    waitScreenMessage: '', SetWaitScreenMessage: (value: string) => { },
    waitScreenShouldShow: false, SetWaitScreenShouldShow: (value: boolean) => { },
    //keyboard control
    keyboardHeight: 0, SetKeyboardHeight: (value: number) => { },
    //database
    // sponsors: [] as Sponsor[], SetSponsors: (value: Sponsor[]) => { }, ---deprecated of unused
    // databaseActionMode: '', SetDatabaseActionMode: (value: string) => { },
    // SetDatabaseActionParams: (value: any) => { },
    databaseActionModeQueueRef: {} as any,
    databaseActionModeQueue: [] as string[], SetDatabaseActionModeQueue: (value: string[]) => { },
    databaseActionParamsQueueRef: {} as any,
    databaseActionParamsQueue: [] as any[], SetDatabaseActionParamsQueue: (value: any) => { },
    databaseResultAction: null as any,
    databaseShouldShowWaitScreen: true, SetDatabaseShouldShowWaitScreen: (value: boolean) => { },
    //phone local storage
    storageRequestMode: '', SetStorageRequestMode: (value: string) => { },
    storageRequestParams: [] as any, SetStorageRequestParams: (value: any) => { },
    storageRequestResultAction: null as any, SetStorageRequestResultAction: (value: any) => { },
    //user profile
    user: {} as MemberUser, SetUser: (value: MemberUser) => { },
    //broadcasts
    broadcasts: [] as Broadcast[], SetBroadcasts: (broadcasts: Broadcast[]) => { },
    //app controller
    appStateChangeWatch: true as boolean, SetAppStateChangeWatch: (value: boolean) => { },
    appListenerActions: [] as any[], SetAppListenerActions: (value: any[]) => { },
    //route controller
    routeControlHistoryStacks: [] as string[], SetRouteControlHistoryStacks: (value: string[]) => { },
    routeControlHistoryBackAction: {} as any, SetRouteControlHistoryBackAction: (value: any) => { },
    notificationMode: 0 as number, SetNotificationMode: (value: number) => {},
    localNotifications: [] as Notification[], SetLocalNotifications: (value: Notification[]) => { },
    shouldClearAllPendings: false as boolean, SetShouldClearAllPendings: (value: boolean) => { },
    // routeControlHistoryStayAction: {} as any, SetRouteControlHistoryStayAction: (value: any) => { } --deprecated
    shouldShowNotices: true as boolean, SetShouldShowNotices: (value: boolean) => {}
});

export const ExAppContext = createContext({
    //OTHERS
    viewMode: 0 as number, SetViewMode: (value: number) => { },
    // events: [] as Event[], SetEvents: (value: Event[]) => { }, ---deprecated of unused
    // currentSelectedEvent: {} as Event, SetCurrentSelectedEvent: (value: Event) => { }, ---deprecated of unused
    currentSelectedMemberUser: {} as MemberUser, SetCurrentSelectedMemberUser: (value: MemberUser) => { },
    //GENERAL
    committeeTypes: [] as CommitteeType[], SetCommitteeTypes: (value: CommitteeType[]) => { },
    eventCategories: [] as EventCategory[], SetEventCategories: (value: EventCategory[]) => { },
    memberTypes: [] as MemberType[], SetMemberTypes: (value: MemberType[]) => { },
    memberFees: [] as MemberFee[], SetMemberFees: (value: MemberFee[]) => { },
    invoiceNotes: [] as InvoiceNote[], SetInvoiceNotes: (value: InvoiceNote[]) => {},
    documentCategories: [] as DocumentCategory[], SetDocumentCategories: (value: DocumentCategory[]) => {},
    broadcasts: [] as Broadcast[], SetBroadcasts: (value: Broadcast[]) => { },
    //MEMBER USERS
    membershipRegistration: {} as MembershipRegistration, SetMembershipRegistration: (value: MembershipRegistration) => { },
    membership: {} as Member, SetMembership: (value: Member) => { },
    membershipUsers: [] as MemberUser[], SetMembershipUsers: (value: MemberUser[]) => {},
    membershipContracts: [] as MembershipContract[], SetMembershipContracts: (value: MembershipContract[]) => { },
    // onGoingEvents: [] as Event[], SetOnGoingEvents: (value: Event[]) => { }, ---deprecated of unuse
    userEventRegistrations: [] as EventRegistration[], SetUserEventRegistrations: (value: EventRegistration[]) => { },
    userUpcomingEvents: [] as Event[], SetUserUpcomingEvents: (value: Event[]) => { },
    viewableDocuments: [] as Document[], SetViewableDocuments: (value: Document[]) => { },
    //COMMITTEES
    allDocuments: [] as Document[], SetAllDocuments: (value: Document[]) => { },
    // allEvents: [] as Event[], SetAllEvents: (value: Event[]) => { }, --deprecated
    allCommitteeMembers: [] as MemberUser[], SetAllCommitteeMembers: (value: MemberUser[]) => { },
    meetingInvitations: [] as MeetingInvitation[], SetMeetingInvitations: (value: MeetingInvitation[]) => { },
    acceptedUpcomingMeetings: [] as Event[], SetAcceptedUpcomingMeetings: (value: Event[]) => {},
    unvotedCurrentAndVotedPolls: [] as Poll[], SetUnvotedCurrentAndVotedPolls: (value: Poll[]) => {},
    hostedMeetings: [] as Event[], SetHostedMeetings: (value: Event[]) => { },
    hostedMeetingInvitations: [] as MeetingInvitation[], SetHostedMeetingInvitations: (value: MeetingInvitation[]) => { },
    hostedMeetingAttachments: [] as EventItem[], SetHostedMeetingAttachments: (value: EventItem[]) => {},
    hostedPolls: [] as Poll[], SetHostedPolls: (value: Poll[]) => {},
    ongoingEvents: [] as Event[], SetOngoingEvents: (value: Event[]) => {}
});